module.exports = __webpack_public_path__ + "static/fonts/Enter-The-Grid.891c61b.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/fonts/Enter-The-Grid.ttf
// module id = M3xG
// module chunks = 0